import React, { useState } from 'react';

// Griglia di autovalutazione 1–5 delle competenze del CV (tracker, 23/10).
// Un clic per riga sceglie il voto (un secondo clic sullo stesso lo toglie);
// le righe senza voto valgono come saltate. «Invia» manda tutti i voti insieme.
export default function GrigliaVoti({ griglia, onInvia, disabled }) {
  const scala = griglia.scala?.length ? griglia.scala : [1, 2, 3, 4, 5];
  const [voti, setVoti] = useState(() =>
    Object.fromEntries((griglia.voci ?? []).filter((v) => v.voto).map((v) => [v.id, v.voto])),
  );
  if (!griglia.voci?.length) return null;

  const scegli = (id, voto) =>
    setVoti((prima) => {
      const dopo = { ...prima };
      if (dopo[id] === voto) delete dopo[id];
      else dopo[id] = voto;
      return dopo;
    });

  const dati = griglia.voci.filter((v) => voti[v.id]);
  const invia = () => {
    const riepilogo = dati.length
      ? dati.map((v) => `${v.label} ${voti[v.id]}`).join(' · ')
      : 'Salto l\u2019autovalutazione';
    onInvia(voti, riepilogo);
  };

  return (
    <div className="sa-griglia" role="group" aria-label="Autovalutazione delle competenze da 1 a 5">
      <div className="sa-griglia-legenda">
        <span>1 = base</span>
        <span>5 = esperto</span>
      </div>
      {griglia.voci.map((v) => (
        <div className="sa-griglia-riga" key={v.id}>
          <div className="sa-griglia-voce">
            <span>{v.label}</span>
            {v.voto_precedente ? (
              <span className="sa-griglia-prima">l'ultima volta: {v.voto_precedente}</span>
            ) : null}
          </div>
          <div className="sa-griglia-scala" role="radiogroup" aria-label={v.label}>
            {scala.map((n) => (
              <button
                key={n}
                type="button"
                role="radio"
                aria-checked={voti[v.id] === n}
                className={`sa-griglia-voto${voti[v.id] === n ? ' is-scelto' : ''}`}
                disabled={disabled}
                onClick={() => scegli(v.id, n)}
              >
                {n}
              </button>
            ))}
          </div>
        </div>
      ))}
      <div className="sa-griglia-azioni">
        <span className="sa-griglia-conteggio">
          {dati.length} di {griglia.voci.length} valutate · le altre si saltano
        </span>
        <button type="button" className="btn btn-primary" disabled={disabled} onClick={invia}>
          {dati.length ? 'Invia la valutazione' : 'Salta tutte'}
        </button>
      </div>
    </div>
  );
}
